var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/index.ts
import { appendGiphySDKRequestHeader } from "@giphy/js-util";

// src/components/attribution/index.tsx
import React4 from "react";
import styled3 from "styled-components";

// src/components/attribution/avatar.tsx
import React, { useRef } from "react";
import styled from "styled-components";
var getSmallAvatar = (avatar) => {
  var _a, _b;
  if (!avatar)
    return "";
  const ext = (_b = (_a = avatar == null ? void 0 : avatar.split(".")) == null ? void 0 : _a.pop()) == null ? void 0 : _b.toLowerCase();
  return avatar.replace(`.${ext}`, `/80h.${ext}`);
};
var Img = styled.img`
    object-fit: cover;
    width: 32px;
    height: 32px;
    margin-right: 8px;
`;
var Avatar = ({ user, className = "" }) => {
  const defaultAvatarId = useRef(Math.floor(Math.random() * 5) + 1);
  const url = user.avatar_url ? getSmallAvatar(user.avatar_url) : `https://media.giphy.com/avatars/default${defaultAvatarId.current}.gif`;
  return /* @__PURE__ */ React.createElement(Img, { src: url, className });
};
var avatar_default = Avatar;

// src/components/attribution/user.tsx
import React3 from "react";
import styled2 from "styled-components";

// src/components/attribution/verified-badge.tsx
import { giphyBlack } from "@giphy/colors";
import React2 from "react";
var VerifiedBadge = ({ className = "", size = 17, fill = "#15CDFF" }) => /* @__PURE__ */ React2.createElement("svg", { className: [VerifiedBadge.className, className].join(" "), height: size, width: "19px", viewBox: "0 0 19 17" }, /* @__PURE__ */ React2.createElement(
  "path",
  {
    className: VerifiedBadge.checkMarkClassName,
    d: "M9.32727273,9.44126709 L9.32727273,3.03016561 L6.55027155,3.03016561 L6.55027155,10.8150746 L6.55027155,12.188882 L12.1042739,12.188882 L12.1042739,9.44126709 L9.32727273,9.44126709 Z",
    fill: giphyBlack,
    transform: "translate(9.327273, 7.609524) scale(-1, 1) rotate(-45.000000) translate(-9.327273, -7.609524) "
  }
), /* @__PURE__ */ React2.createElement("g", { transform: "translate(-532.000000, -466.000000)", fill }, /* @__PURE__ */ React2.createElement("g", { transform: "translate(141.000000, 235.000000)" }, /* @__PURE__ */ React2.createElement("g", { transform: "translate(264.000000, 0.000000)" }, /* @__PURE__ */ React2.createElement("g", { transform: "translate(10.000000, 224.000000)" }, /* @__PURE__ */ React2.createElement("g", { transform: "translate(114.000000, 2.500000)" }, /* @__PURE__ */ React2.createElement("path", { d: "M15.112432,4.80769231 L16.8814194,6.87556817 L19.4157673,7.90116318 L19.6184416,10.6028916 L21.0594951,12.9065042 L19.6184416,15.2101168 L19.4157673,17.9118452 L16.8814194,18.9374402 L15.112432,21.0053161 L12.4528245,20.3611511 L9.79321699,21.0053161 L8.02422954,18.9374402 L5.48988167,17.9118452 L5.28720734,15.2101168 L3.84615385,12.9065042 L5.28720734,10.6028916 L5.48988167,7.90116318 L8.02422954,6.87556817 L9.79321699,4.80769231 L12.4528245,5.4518573 L15.112432,4.80769231 Z M17.8163503,10.8991009 L15.9282384,9.01098901 L11.5681538,13.3696923 L9.68115218,11.4818515 L7.81302031,13.3499833 L9.7011322,15.2380952 L11.5892441,17.1262071 L17.8163503,10.8991009 Z" })))))));
VerifiedBadge.className = "giphy-verified-badge";
VerifiedBadge.checkMarkClassName = "giphy-verified-checkmark";
var verified_badge_default = VerifiedBadge;

// src/components/attribution/user.tsx
var Username = styled2.div`
    color: white;
    font-size: 16px;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    -webkit-font-smoothing: antialiased;
`;
var VerifiedBadge2 = styled2(verified_badge_default)`
    margin-left: 4px;
    flex-shrink: 0;
`;
var Container = styled2.div`
    display: flex;
    align-items: center;
    min-width: 0;
`;
var User = ({ user }) => {
  const { display_name, username } = user;
  return /* @__PURE__ */ React3.createElement(Container, null, /* @__PURE__ */ React3.createElement(Username, null, display_name || `@${username}`), user.is_verified ? /* @__PURE__ */ React3.createElement(VerifiedBadge2, { size: 14 }) : null);
};
var user_default = User;

// src/components/attribution/index.tsx
var Container2 = styled3.div`
    display: flex;
    align-items: center;
    font-family: interface, helvetica, arial;
`;
var Avatar2 = styled3(avatar_default)`
    flex-shrink: 0;
`;
var Attribution = ({ gif, className, onClick }) => {
  const { user } = gif;
  if (!(user == null ? void 0 : user.username) && !(user == null ? void 0 : user.display_name)) {
    return null;
  }
  return /* @__PURE__ */ React4.createElement(
    Container2,
    {
      className: [Attribution.className, className].join(" "),
      onClick: (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (onClick) {
          onClick(gif);
        } else {
          const url = user.profile_url;
          if (url)
            window.open(url, "_blank");
        }
      }
    },
    /* @__PURE__ */ React4.createElement(Avatar2, { user }),
    /* @__PURE__ */ React4.createElement(user_default, { user: gif.user })
  );
};
Attribution.className = "giphy-attribution";
var attribution_default = Attribution;

// src/components/attribution/overlay.tsx
import React5, { useRef as useRef2 } from "react";
import styled4 from "styled-components";
var Background = styled4.div`
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(18, 18, 18, 0.6));
    cursor: default;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 75px;
    pointer-events: none;
`;
var Attribution2 = styled4(attribution_default)`
    position: absolute;
    bottom: 10px;
    left: 10px;
    right: 10px;
`;
var Container3 = styled4.div`
    transition: opacity 150ms ease-in;
`;
var AttributionOverlay = ({ gif, isHovered, onClick }) => {
  const hasHovered = useRef2(isHovered);
  if (isHovered) {
    hasHovered.current = true;
  }
  return gif.user && hasHovered.current ? /* @__PURE__ */ React5.createElement(Container3, { style: { opacity: isHovered ? 1 : 0 } }, /* @__PURE__ */ React5.createElement(Background, null), /* @__PURE__ */ React5.createElement(Attribution2, { gif, onClick })) : null;
};
var overlay_default = AttributionOverlay;

// src/components/carousel.tsx
import { gifPaginator } from "@giphy/js-fetch-api";
import { getGifWidth } from "@giphy/js-util";
import React9, { PureComponent } from "react";
import styled6 from "styled-components";
import { debounce } from "throttle-debounce";

// src/util/observer.tsx
import "intersection-observer";
import React6, { useEffect, useRef as useRef3 } from "react";
var Observer = ({ children, className, onVisibleChange, config }) => {
  const container = useRef3(null);
  useEffect(() => {
    let io;
    if (container.current) {
      io = new IntersectionObserver(([entry]) => {
        if (onVisibleChange)
          onVisibleChange(entry.isIntersecting);
      }, config);
      io.observe(container.current);
    }
    return () => io == null ? void 0 : io.disconnect();
  }, [onVisibleChange, container, config]);
  return /* @__PURE__ */ React6.createElement("div", { ref: container, className }, children);
};
var observer_default = Observer;

// src/components/gif.tsx
import { giphyBlue, giphyGreen, giphyPurple, giphyRed, giphyYellow } from "@giphy/colors";
import { Logger, getAltText, getBestRendition, getGifHeight } from "@giphy/js-util";
import "intersection-observer";
import React8, { useContext as useContext2, useEffect as useEffect2, useRef as useRef4, useState } from "react";
import styled5 from "styled-components";

// src/util/pingback.ts
import { pingback } from "@giphy/js-analytics";
import { getClientRect } from "@giphy/js-util";
var firePingback = (actionType) => (gif, userId, target, attributes = {}) => {
  if (!gif.analytics_response_payload) {
    return;
  }
  pingback({
    analyticsResponsePayload: gif.analytics_response_payload,
    userId,
    actionType,
    attributes: __spreadValues({ position: JSON.stringify(getClientRect(target)) }, attributes)
  });
};
var onGifSeen = (gif, userId, position, attributes = {}) => {
  if (!gif.analytics_response_payload) {
    return;
  }
  pingback({
    analyticsResponsePayload: gif.analytics_response_payload,
    userId,
    actionType: "SEEN",
    attributes: __spreadValues({ position: JSON.stringify(position) }, attributes)
  });
};
var onGifClick = firePingback("CLICK");
var onGifHover = firePingback("HOVER");

// src/components/pingback-context-manager.tsx
import { mergeAttributes } from "@giphy/js-analytics";
import React7, { createContext, useContext } from "react";
var PingbackContext = createContext({});
var PingbackContextManager = ({ attributes, children }) => {
  const { attributes: parentAttributes = {} } = useContext(PingbackContext);
  return /* @__PURE__ */ React7.createElement(PingbackContext.Provider, { value: { attributes: mergeAttributes(parentAttributes, attributes, "layout_type") } }, children);
};
var pingback_context_manager_default = PingbackContextManager;

// src/components/gif.tsx
var Container4 = styled5.div`
    position: relative;
    display: block;
    img {
        display: block;
    }
    .${verified_badge_default.className} {
        g {
            fill: white;
        }
    }
    .${verified_badge_default.checkMarkClassName} {
        opacity: 0;
    }
`;
var GRID_COLORS = [giphyBlue, giphyGreen, giphyPurple, giphyRed, giphyYellow];
var getColor = () => GRID_COLORS[Math.round(Math.random() * (GRID_COLORS.length - 1))];
var hoverTimeoutDelay = 200;
var placeholder = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var noop = () => {
};
var RenderOnClient = ({ children }) => {
  const [render, setRender] = useState(false);
  useEffect2(() => {
    setRender(true);
  }, []);
  return render ? /* @__PURE__ */ React8.createElement(React8.Fragment, null, children) : null;
};
var Gif = ({
  gif,
  width,
  percentWidth,
  height: forcedHeight,
  onGifRightClick = noop,
  className = "",
  onGifClick: onGifClick2 = noop,
  onGifKeyPress = noop,
  onGifSeen: onGifSeen2 = noop,
  onGifVisible = noop,
  user = {},
  backgroundColor,
  overlay,
  hideAttribution = false,
  noLink = false,
  borderRadius = 4,
  style,
  tabIndex
}) => {
  const [hasFiredSeen, setHasFiredSeen] = useState(false);
  const [isHovered, setHovered] = useState(false);
  const [shouldShowMedia, setShouldShowMedia] = useState(!canUseDOM);
  const [loadedClassname, setLoadedClassName] = useState("");
  const defaultBgColor = useRef4(getColor());
  const container = useRef4(null);
  const image = useRef4(null);
  const showGifObserver = useRef4();
  const fullGifObserver = useRef4();
  const hoverTimeout = useRef4();
  const sendOnSeen = useRef4(noop);
  const { attributes } = useContext2(PingbackContext);
  let Overlay = overlay;
  if (!Overlay && !hideAttribution) {
    Overlay = overlay_default;
  }
  const onMouseOver = (e) => {
    clearTimeout(hoverTimeout.current);
    e.persist();
    setHovered(true);
    hoverTimeout.current = window.setTimeout(() => {
      onGifHover(gif, user == null ? void 0 : user.id, e.target, attributes);
    }, hoverTimeoutDelay);
  };
  const onMouseLeave = () => {
    clearTimeout(hoverTimeout.current);
    setHovered(false);
  };
  const onClick = (e) => {
    onGifClick(gif, user == null ? void 0 : user.id, e.target, attributes);
    onGifClick2(gif, e);
  };
  const onKeyPress = (e) => {
    onGifKeyPress(gif, e);
  };
  sendOnSeen.current = (entry) => {
    setHasFiredSeen(true);
    Logger.debug(`GIF ${gif.id} seen. ${gif.title}`);
    onGifSeen(gif, user == null ? void 0 : user.id, entry.boundingClientRect, attributes);
    onGifSeen2 == null ? void 0 : onGifSeen2(gif, entry.boundingClientRect);
    if (fullGifObserver.current) {
      fullGifObserver.current.disconnect();
    }
  };
  const watchGif = () => {
    if (!fullGifObserver.current) {
      fullGifObserver.current = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            sendOnSeen.current(entry);
          }
        },
        { threshold: [0.99] }
      );
    }
    if (!hasFiredSeen && container.current && fullGifObserver.current) {
      fullGifObserver.current.observe(container.current);
    }
  };
  const onImageLoad = (e) => {
    watchGif();
    onGifVisible(gif, e);
    setLoadedClassName(Gif.imgLoadedClassName);
  };
  useEffect2(() => {
    var _a, _b;
    if ((_a = image.current) == null ? void 0 : _a.complete) {
      watchGif();
      onGifVisible(gif);
    }
    (_b = fullGifObserver.current) == null ? void 0 : _b.disconnect();
    setHasFiredSeen(false);
  }, [gif.id]);
  useEffect2(() => {
    showGifObserver.current = new IntersectionObserver(([entry]) => {
      const { isIntersecting } = entry;
      setShouldShowMedia(isIntersecting);
      if (!isIntersecting && fullGifObserver.current) {
        fullGifObserver.current.disconnect();
      }
    });
    showGifObserver.current.observe(container.current);
    return () => {
      if (showGifObserver.current)
        showGifObserver.current.disconnect();
      if (fullGifObserver.current)
        fullGifObserver.current.disconnect();
      if (hoverTimeout.current)
        clearTimeout(hoverTimeout.current);
    };
  }, []);
  const height = forcedHeight || getGifHeight(gif, width);
  let percentHeight;
  if (percentWidth) {
    const ratio = Math.round(height / width * 100);
    percentHeight = `${ratio}%`;
  }
  const bestRendition = getBestRendition(gif.images, width, height);
  const rendition = gif.images[bestRendition.renditionName];
  const background = backgroundColor || // <- specified background prop
  // sticker has black if no backgroundColor is specified
  (gif.is_sticker ? `url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4AQMAAACSSKldAAAABlBMVEUhIiIWFhYoSqvJAAAAGElEQVQY02MAAv7///8PWxqIPwDZw5UGABtgwz2xhFKxAAAAAElFTkSuQmCC') 0 0` : defaultBgColor.current);
  const overflow = borderRadius ? "hidden" : "unset";
  return /* @__PURE__ */ React8.createElement(
    Container4,
    {
      as: noLink ? "div" : "a",
      href: noLink ? void 0 : gif.url,
      "data-giphy-id": gif.id,
      "data-giphy-is-sticker": gif.is_sticker,
      style: __spreadValues({
        width: percentWidth || width,
        height: percentHeight || height,
        overflow,
        borderRadius
      }, style),
      className: [Gif.className, className].join(" "),
      onMouseOver,
      onMouseLeave,
      onClick,
      onContextMenu: (e) => onGifRightClick(gif, e),
      onKeyPress,
      tabIndex,
      ref: container
    },
    /* @__PURE__ */ React8.createElement("picture", null, /* @__PURE__ */ React8.createElement(
      "source",
      {
        type: "image/webp",
        srcSet: shouldShowMedia ? rendition.webp : placeholder,
        suppressHydrationWarning: true
      }
    ), /* @__PURE__ */ React8.createElement(
      "img",
      {
        ref: image,
        suppressHydrationWarning: true,
        className: [Gif.imgClassName, loadedClassname].join(" "),
        src: shouldShowMedia ? rendition.url : placeholder,
        style: { background },
        width: "100%",
        height: "100%",
        alt: getAltText(gif),
        onLoad: shouldShowMedia ? onImageLoad : () => {
        }
      }
    )),
    Overlay && // only render the overlay on the client since it depends on shouldShowMedia
    /* @__PURE__ */ React8.createElement(RenderOnClient, null, shouldShowMedia && /* @__PURE__ */ React8.createElement(Overlay, { gif, isHovered, width, height }))
  );
};
Gif.className = "giphy-gif";
Gif.imgClassName = "giphy-gif-img";
Gif.imgLoadedClassName = "giphy-img-loaded";
var gif_default = Gif;

// src/components/carousel.tsx
var Container5 = styled6.div`
    -webkit-overflow-scrolling: touch;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    position: relative;
`;
var Gif2 = styled6(gif_default)`
    position: relative;
    display: inline-block;
    list-style: none;
    margin-left: ${(props) => props.ml}px;
    /* make sure gifs are fully visible with a scrollbar */
    margin-bottom: 1px;

    &:first-of-type {
        margin-left: 0;
    }
    .${gif_default.imgClassName} {
        position: absolute;
        top: 0;
        left: 0;
    }
`;
var Observer2 = styled6(observer_default)`
    display: inline-block;
`;
var Loader = styled6.div`
    width: 30px;
    display: inline-block;
    opacity: ${(props) => props.isFirstLoad ? 0 : 1};
    height: ${(props) => props.height}px;
`;
var defaultProps = Object.freeze({ gutter: 6, user: {}, initialGifs: [] });
var initialState = Object.freeze({
  isFetching: false,
  gifs: [],
  isLoaderVisible: false,
  isDoneFetching: false
});
var _Carousel = class _Carousel extends PureComponent {
  constructor() {
    super(...arguments);
    this.state = __spreadProps(__spreadValues({}, initialState), { gifs: this.props.initialGifs || [] });
    this.unmounted = false;
    this.paginator = gifPaginator(this.props.fetchGifs, this.state.gifs);
    this.onLoaderVisible = (isVisible) => {
      if (this.unmounted)
        return;
      this.setState({ isLoaderVisible: isVisible }, this.onFetch);
    };
    this.onFetch = debounce(100, () => __async(this, null, function* () {
      if (this.unmounted)
        return;
      const { isFetching, isLoaderVisible, gifs: existingGifs } = this.state;
      if (!isFetching && isLoaderVisible) {
        this.setState({ isFetching: true });
        let gifs;
        try {
          gifs = yield this.paginator();
        } catch (error) {
          this.setState({ isFetching: false });
        }
        if (gifs) {
          if (existingGifs.length === gifs.length) {
            this.setState({ isDoneFetching: true });
          } else {
            this.setState({ gifs, isFetching: false });
            const { onGifsFetched } = this.props;
            if (onGifsFetched)
              onGifsFetched(gifs);
            this.onFetch();
          }
        }
      }
    }));
  }
  componentDidMount() {
    this.unmounted = false;
    this.onFetch();
  }
  componentWillUnmount() {
    this.unmounted = true;
  }
  render() {
    const {
      onGifVisible,
      onGifRightClick,
      gifHeight,
      gifWidth,
      gutter,
      className = _Carousel.className,
      onGifSeen: onGifSeen2,
      onGifClick: onGifClick2,
      onGifKeyPress,
      user,
      overlay,
      hideAttribution,
      noLink,
      noResultsMessage,
      backgroundColor,
      borderRadius,
      tabIndex = 0,
      loaderConfig
    } = this.props;
    const { gifs, isDoneFetching } = this.state;
    const showLoader = !isDoneFetching;
    const isFirstLoad = gifs.length === 0;
    return /* @__PURE__ */ React9.createElement(pingback_context_manager_default, { attributes: { layout_type: "CAROUSEL" } }, /* @__PURE__ */ React9.createElement(Container5, { className }, gifs.map((gif) => {
      return /* @__PURE__ */ React9.createElement(
        Gif2,
        {
          gif,
          key: gif.id,
          tabIndex,
          width: gifWidth || getGifWidth(gif, gifHeight),
          height: gifHeight,
          onGifClick: onGifClick2,
          onGifKeyPress,
          onGifSeen: onGifSeen2,
          onGifVisible,
          onGifRightClick,
          user,
          ml: gutter,
          overlay,
          hideAttribution,
          noLink,
          borderRadius,
          backgroundColor
        }
      );
    }), !showLoader && gifs.length === 0 && noResultsMessage, showLoader && /* @__PURE__ */ React9.createElement(Observer2, { onVisibleChange: this.onLoaderVisible, config: loaderConfig }, /* @__PURE__ */ React9.createElement(Loader, { isFirstLoad, height: gifHeight }))));
  }
};
_Carousel.className = "giphy-carousel";
_Carousel.defaultProps = defaultProps;
var Carousel = _Carousel;
var carousel_default = Carousel;

// src/components/emoji-variations-list.tsx
import { giphyCharcoal, giphyDarkGrey } from "@giphy/colors";
import { getGifWidth as getGifWidth2 } from "@giphy/js-util";
import React11, { useEffect as useEffect3 } from "react";
import useAsyncFn from "react-use/lib/useAsyncFn";
import useLatest from "react-use/lib/useLatest";
import styled8 from "styled-components";

// src/components/fetch-error.tsx
import { giphyBlue as giphyBlue2, giphyLightGrey } from "@giphy/colors";
import React10 from "react";
import styled7 from "styled-components";
var Message = styled7.div`
    color: ${giphyLightGrey};
    display: flex;
    justify-content: center;
    margin: 30px 0;
    font-family: interface, Helvetica Neue, helvetica, sans-serif;
    font-size: 16px;
    font-weight: 600;
    a {
        color: ${giphyBlue2};
        cursor: pointer;
        &:hover {
            color: white;
        }
    }
`;
var FetchError = ({ onClick }) => /* @__PURE__ */ React10.createElement(Message, null, "Error loading GIFs.\xA0", /* @__PURE__ */ React10.createElement("a", { onClick }, "Try again?"));
var fetch_error_default = FetchError;

// src/components/emoji-variations-list.tsx
var DEFAULT_BG_COLOR = giphyDarkGrey;
var DEFAULT_DIVIDER_COLOR = giphyCharcoal;
var DIVIDER_RELATIVE_HEIGHT = 0.75;
var Root = styled8.div`
    align-items: center;
    background-color: ${({ backgroundColor }) => backgroundColor};
    border-radius: 16px;
    display: flex;
    max-width: fit-content;
    overflow: hidden;
    padding: 4px 5px 5px 6px;
`;
var VariationsViewport = styled8.div`
    overflow-x: auto;
    overflow-y: hidden;
    position: relative;
    -webkit-overflow-scrolling: touch;
`;
var VariationsContainer = styled8.div`
    display: inline-flex;
    justify-content: space-between;
    overflow: hidden;
    white-space: nowrap;
    width: ${({ width }) => `${width}px`};
`;
var Divider = styled8.div`
    background-color: ${({ color }) => color};
    box-sizing: border-box;
    height: ${({ gifHeight }) => `${Math.round(gifHeight * DIVIDER_RELATIVE_HEIGHT)}px`};
    margin: ${({ gutter }) => `0 ${gutter}px`};
    width: 2px;
`;
var Emoji = styled8(gif_default)`
    display: inline-block;
    flex-shrink: 0;
    list-style: none;
    /* make sure gifs are fully visible with a scrollbar */
    margin-bottom: 1px;
    position: relative;

    .${gif_default.imgClassName} {
        position: absolute;
        top: 0;
        left: 0;
    }
`;
function EmojiVariationsList(props) {
  var _b;
  const _a = props, {
    backgroundColor = DEFAULT_BG_COLOR,
    className,
    dividerColor = DEFAULT_DIVIDER_COLOR,
    fetchVariations,
    gif,
    gifHeight,
    GifProps = {},
    gifWidth: gifWidthProp,
    gutter = 6,
    hideAttribution,
    loader: LoaderComponent,
    noLink,
    onGifClick: onGifClick2,
    onGifKeyPress,
    onGifRightClick,
    onGifSeen: onGifSeen2,
    onGifVisible,
    onVariationsFetched,
    overlay,
    tabIndex = 0,
    user
  } = _a, other = __objRest(_a, [
    "backgroundColor",
    "className",
    "dividerColor",
    "fetchVariations",
    "gif",
    "gifHeight",
    "GifProps",
    "gifWidth",
    "gutter",
    "hideAttribution",
    "loader",
    "noLink",
    "onGifClick",
    "onGifKeyPress",
    "onGifRightClick",
    "onGifSeen",
    "onGifVisible",
    "onVariationsFetched",
    "overlay",
    "tabIndex",
    "user"
  ]);
  const variationCount = (_b = gif.variation_count) != null ? _b : 0;
  const gifWidth = gifWidthProp || getGifWidth2(gif, gifHeight);
  const variationsContainerWidth = variationCount * gifWidth + Math.max(0, variationCount - 1) * gutter;
  const fetchVariationsRef = useLatest(fetchVariations);
  const onVariationsFetchedRef = useLatest(onVariationsFetched);
  const [variationsState, syncVariations] = useAsyncFn(
    () => __async(this, null, function* () {
      var _a2;
      const result = yield fetchVariationsRef.current(gif.id);
      const variations = (_a2 = result == null ? void 0 : result.data) != null ? _a2 : [];
      if (onVariationsFetchedRef.current) {
        onVariationsFetchedRef.current(variations);
      }
      return variations;
    }),
    [gif],
    { loading: true, value: [] }
  );
  useEffect3(() => {
    syncVariations();
  }, [syncVariations]);
  const emojiCommonProps = __spreadValues({
    backgroundColor: "transparent",
    height: gifHeight,
    hideAttribution,
    noLink,
    onGifClick: onGifClick2,
    onGifKeyPress,
    onGifRightClick,
    onGifSeen: onGifSeen2,
    onGifVisible,
    overlay,
    tabIndex,
    user,
    width: gifWidth
  }, GifProps);
  const getVariationsContent = () => {
    var _a2;
    if (variationsState.loading) {
      return LoaderComponent ? /* @__PURE__ */ React11.createElement(LoaderComponent, { className: EmojiVariationsList.loaderClassName }) : null;
    }
    if (variationsState.error) {
      return /* @__PURE__ */ React11.createElement(fetch_error_default, { onClick: syncVariations });
    }
    return /* @__PURE__ */ React11.createElement(React11.Fragment, null, ((_a2 = variationsState.value) != null ? _a2 : []).map((gif2) => /* @__PURE__ */ React11.createElement(Emoji, __spreadProps(__spreadValues({}, emojiCommonProps), { key: gif2.id, gif: gif2 }))));
  };
  return /* @__PURE__ */ React11.createElement(
    Root,
    __spreadValues({
      backgroundColor,
      className: [EmojiVariationsList.className, className].join(" ")
    }, other),
    /* @__PURE__ */ React11.createElement(Emoji, __spreadProps(__spreadValues({}, emojiCommonProps), { gif })),
    variationCount ? /* @__PURE__ */ React11.createElement(
      Divider,
      {
        className: EmojiVariationsList.dividerClassName,
        color: dividerColor,
        gifHeight,
        gutter
      }
    ) : null,
    /* @__PURE__ */ React11.createElement(VariationsViewport, { className: EmojiVariationsList.variationsViewportClassName }, /* @__PURE__ */ React11.createElement(
      VariationsContainer,
      {
        className: EmojiVariationsList.variationsContainerClassName,
        width: variationsContainerWidth
      },
      getVariationsContent()
    ))
  );
}
EmojiVariationsList.className = "giphy-emoji-variations-list";
EmojiVariationsList.dividerClassName = "giphy-emoji-variations-divider";
EmojiVariationsList.loaderClassName = "giphy-emoji-variations-loader";
EmojiVariationsList.variationsViewportClassName = "giphy-emoji-variations-viewport";
EmojiVariationsList.variationsContainerClassName = "giphy-emoji-variations-container";

// src/components/grid.tsx
import { gifPaginator as gifPaginator2 } from "@giphy/js-fetch-api";
import { getGifHeight as getGifHeight2 } from "@giphy/js-util";
import React14, { PureComponent as PureComponent2 } from "react";
import styled10 from "styled-components";
import { debounce as debounce2 } from "throttle-debounce";

// src/components/loader.tsx
import { giphyBlue as giphyBlue3, giphyGreen as giphyGreen2, giphyPurple as giphyPurple2, giphyRed as giphyRed2, giphyYellow as giphyYellow2 } from "@giphy/colors";
import React12 from "react";
import styled9, { keyframes } from "styled-components";
var bouncer = keyframes`
     to {
    transform: scale(1.75) translateY(-20px);
  }
`;
var loaderHeight = 37;
var Container6 = styled9.div`
    display: flex;
    align-items: center;
    height: ${loaderHeight}px;
    padding-top: 15px;
    margin: 0 auto;
    text-align: center;
    justify-content: center;
    animation: pulse 0.8s ease-in-out 0s infinite alternate backwards;
`;
var Dot = styled9.div`
    display: inline-block;
    height: 10px;
    width: 10px;
    margin: ${loaderHeight}px 10px 10px 10px;
    position: relative;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.3);
    animation: ${bouncer} cubic-bezier(0.455, 0.03, 0.515, 0.955) 0.75s infinite alternate;
    background: ${(props) => props.color};
    animation-delay: ${(props) => props.delay};
`;
var Loader2 = ({ className = "" }) => /* @__PURE__ */ React12.createElement(Container6, { className }, /* @__PURE__ */ React12.createElement(Dot, { color: giphyGreen2, delay: "0" }), /* @__PURE__ */ React12.createElement(Dot, { color: giphyBlue3, delay: ".1s" }), /* @__PURE__ */ React12.createElement(Dot, { color: giphyPurple2, delay: ".2s" }), /* @__PURE__ */ React12.createElement(Dot, { color: giphyRed2, delay: ".3s" }), /* @__PURE__ */ React12.createElement(Dot, { color: giphyYellow2, delay: ".4s" }));
var loader_default = Loader2;

// src/components/masonry-grid.tsx
import React13, { memo } from "react";
function fillArray(length, columnOffsets = []) {
  return Array.apply(null, Array(length)).map((_, index) => columnOffsets[index] || 0);
}
var MasonryGrid = ({
  columns,
  gutter,
  useTransform = true,
  itemWidth,
  itemHeights,
  children,
  columnOffsets = []
}) => {
  const containerStyle = {};
  function getChildren() {
    let columnTarget;
    const columnHeights = fillArray(columns, columnOffsets);
    const result = React13.Children.map(children, (child, index) => {
      const style = {
        position: "absolute"
      };
      columnTarget = columnHeights.indexOf(Math.min.apply(Math, columnHeights));
      const top = `${columnHeights[columnTarget]}px`;
      const left = `${columnTarget * itemWidth + columnTarget * gutter}px`;
      if (useTransform) {
        style.transform = `translate3d(${left}, ${top}, 0)`;
      } else {
        style.top = top;
        style.left = left;
      }
      const height = itemHeights[index];
      if (height) {
        columnHeights[columnTarget] += height + gutter;
      }
      return React13.cloneElement(child, { style });
    });
    containerStyle.position = "relative";
    containerStyle.width = `${columns * itemWidth + (columns - 1) * gutter}px`;
    containerStyle.height = `${Math.max.apply(Math, columnHeights) - gutter}px`;
    return result;
  }
  return /* @__PURE__ */ React13.createElement("div", { style: containerStyle }, getChildren());
};
var masonry_grid_default = memo(MasonryGrid);

// src/components/grid.tsx
var Loader3 = styled10.div`
    opacity: ${(props) => props.isFirstLoad ? 0 : 1};
`;
var defaultProps2 = Object.freeze({ gutter: 6, user: {}, initialGifs: [] });
var initialState2 = Object.freeze({
  isFetching: false,
  isError: false,
  gifWidth: 0,
  gifs: [],
  isLoaderVisible: false,
  isDoneFetching: false
});
var _Grid = class _Grid extends PureComponent2 {
  constructor() {
    super(...arguments);
    this.state = __spreadProps(__spreadValues({}, initialState2), { gifs: this.props.initialGifs || [] });
    this.unmounted = false;
    this.paginator = gifPaginator2(this.props.fetchGifs, this.state.gifs);
    this.onLoaderVisible = (isVisible) => {
      if (this.unmounted)
        return;
      this.setState({ isLoaderVisible: isVisible }, this.onFetch);
    };
    this.onFetch = debounce2(_Grid.fetchDebounce, () => __async(this, null, function* () {
      if (this.unmounted)
        return;
      const { isFetching, isLoaderVisible, gifs } = this.state;
      const prefetchCount = gifs.length;
      if (!isFetching && isLoaderVisible) {
        this.setState({ isFetching: true, isError: false });
        let gifs2;
        try {
          gifs2 = yield this.paginator();
          if (this.unmounted)
            return;
        } catch (error) {
          if (this.unmounted)
            return;
          this.setState({ isFetching: false, isError: true });
          const { onGifsFetchError } = this.props;
          if (onGifsFetchError)
            onGifsFetchError(error);
        }
        if (gifs2) {
          if (prefetchCount === gifs2.length) {
            this.setState({ isDoneFetching: true });
          } else {
            this.setState({ gifs: gifs2, isFetching: false });
            const { onGifsFetched } = this.props;
            if (onGifsFetched)
              onGifsFetched(gifs2);
            this.onFetch();
          }
        }
      }
    }));
  }
  componentDidMount() {
    this.unmounted = false;
    this.onFetch();
  }
  componentWillUnmount() {
    this.unmounted = true;
  }
  render() {
    const {
      onGifVisible,
      onGifRightClick,
      className = _Grid.className,
      onGifSeen: onGifSeen2,
      onGifClick: onGifClick2,
      onGifKeyPress,
      user,
      overlay,
      hideAttribution,
      noLink,
      borderRadius,
      noResultsMessage,
      columns,
      width,
      gutter,
      useTransform,
      columnOffsets,
      backgroundColor,
      loaderConfig,
      tabIndex = 0,
      layoutType = "GRID",
      loader: LoaderVisual = loader_default
    } = this.props;
    const { gifWidth, gifs, isError, isDoneFetching } = this.state;
    const showLoader = !isDoneFetching;
    const isFirstLoad = gifs.length === 0;
    const itemHeights = gifs.map((gif) => getGifHeight2(gif, gifWidth));
    return /* @__PURE__ */ React14.createElement(pingback_context_manager_default, { attributes: { layout_type: layoutType } }, /* @__PURE__ */ React14.createElement("div", { className, style: { width } }, /* @__PURE__ */ React14.createElement(
      masonry_grid_default,
      {
        itemHeights,
        useTransform,
        itemWidth: gifWidth,
        columns,
        gutter,
        columnOffsets
      },
      gifs.map((gif) => /* @__PURE__ */ React14.createElement(
        gif_default,
        {
          gif,
          tabIndex,
          key: gif.id,
          width: gifWidth,
          onGifClick: onGifClick2,
          onGifKeyPress,
          onGifSeen: onGifSeen2,
          onGifVisible,
          onGifRightClick,
          user,
          overlay,
          backgroundColor,
          hideAttribution,
          noLink,
          borderRadius
        }
      ))
    ), !showLoader && gifs.length === 0 && noResultsMessage, isError ? /* @__PURE__ */ React14.createElement(fetch_error_default, { onClick: this.onFetch }) : showLoader && /* @__PURE__ */ React14.createElement(observer_default, { onVisibleChange: this.onLoaderVisible, config: loaderConfig }, /* @__PURE__ */ React14.createElement(Loader3, { isFirstLoad }, /* @__PURE__ */ React14.createElement(LoaderVisual, { className: _Grid.loaderClassName })))));
  }
};
_Grid.className = "giphy-grid";
_Grid.loaderClassName = "loader";
_Grid.fetchDebounce = 250;
_Grid.defaultProps = defaultProps2;
_Grid.getDerivedStateFromProps = ({ columns, gutter, width }, prevState) => {
  const gutterOffset = gutter * (columns - 1);
  const gifWidth = Math.floor((width - gutterOffset) / columns);
  if (prevState.gifWidth !== gifWidth) {
    return { gifWidth };
  }
  return null;
};
var Grid = _Grid;
var grid_default = Grid;

// src/components/search-bar/index.tsx
import { giphyIndigo, giphyLightGrey as giphyLightGrey2 } from "@giphy/colors";
import React20, { useContext as useContext6, useEffect as useEffect5, useRef as useRef5, useState as useState3 } from "react";
import useDebounce from "react-use/lib/useDebounce";
import styled15, { css as css2 } from "styled-components";

// src/components/search-bar/cancel-icon.tsx
import React16, { useContext as useContext3 } from "react";
import styled12 from "styled-components";

// src/components/search-bar/context.tsx
import { giphyBlack as giphyBlack2, giphyCharcoal as giphyCharcoal2, giphyWhite } from "@giphy/colors";
import { GiphyFetch, request } from "@giphy/js-fetch-api";
import { Logger as Logger2 } from "@giphy/js-util";
import React15, { createContext as createContext2, useCallback, useEffect as useEffect4, useMemo, useState as useState2 } from "react";
import styled11, { css } from "styled-components";
var CssVars = {
  searchbarHeight: `--searchbar-height`,
  bgColor: `--searchbar-bg-color`,
  bgColor2: `--searchbar-bg-color-2`,
  fgColor: `--searchbar-fg-color`,
  cancelButtonDisplay: `--searchbar-cancel-button-display`
};
var Container7 = styled11.div`
    ${CssVars.searchbarHeight}: ${(props) => props.searchbarHeight || 42}px;
    @media (${(props) => props.mobileMediaQuery}) {
        ${CssVars.searchbarHeight}: ${(props) => props.mobileSearchbarHeight || 35}px;
    }
    ${CssVars.bgColor}: ${giphyWhite};
    ${CssVars.bgColor2}: ${giphyWhite};
    ${CssVars.fgColor}: ${giphyBlack2};
    ${(props) => props.darkMode && css`
            ${CssVars.fgColor}: ${giphyWhite};
            ${CssVars.bgColor}: ${giphyBlack2};
            ${CssVars.bgColor2}: ${giphyCharcoal2};
        `}
    ${CssVars.cancelButtonDisplay}: ${(props) => props.hideCancelButton ? "none" : "block"};
`;
var SearchContext = createContext2({});
var _SearchContext = createContext2({});
var emptyChannels = [];
var emptyGifsResult = {
  data: [],
  pagination: { total_count: 0, count: 0, offset: 0 },
  meta: { status: 200, msg: "OK", response_id: "" }
};
var SearchContextManager = ({
  children,
  options = {},
  apiKey,
  initialTerm = "",
  initialChannel,
  shouldDefaultToTrending = true,
  shouldFetchChannels = true,
  theme
}) => {
  var _a, _b;
  const gf = useMemo(() => new GiphyFetch(apiKey), [apiKey]);
  const [currentChannels, setChannels] = useState2([]);
  const [term, _setSearch] = useState2(initialTerm);
  const [_inputValOverride, setSearch] = useState2(initialTerm);
  const [isFetching, setIsFetching] = useState2(false);
  const [activeChannel, _setActiveChannel] = useState2(initialChannel);
  const setActiveChannel = useCallback((activeChannel2) => {
    _setSearch("");
    _setActiveChannel(activeChannel2);
  }, []);
  const [trendingSearches, setTrendingSearches] = useState2([]);
  const [isFocused, setIsFocused] = useState2(false);
  const searchKey = [term, options.type, ((_a = activeChannel == null ? void 0 : activeChannel.user) == null ? void 0 : _a.username) || ""].filter((val) => !!val).join(" / ");
  const fetchGifs = useCallback(
    (offset) => __async(void 0, null, function* () {
      var _a2;
      setIsFetching(true);
      let result = emptyGifsResult;
      if (term) {
        result = yield gf.search(term, __spreadProps(__spreadValues({}, options), {
          offset,
          channel: (_a2 = activeChannel == null ? void 0 : activeChannel.user) == null ? void 0 : _a2.username
        }));
      } else if (shouldDefaultToTrending) {
        result = yield gf.trending(__spreadProps(__spreadValues({}, options), { offset }));
      }
      setIsFetching(false);
      return result;
    }),
    [(_b = activeChannel == null ? void 0 : activeChannel.user) == null ? void 0 : _b.username, gf, options, term, shouldDefaultToTrending]
  );
  const fetchAnimatedText = useCallback(
    (offset) => __async(void 0, null, function* () {
      const limit = options.limit || 50;
      const result = yield gf.animate(term, { offset, limit });
      if (!result.pagination) {
        result.pagination = { count: limit, total_count: limit, offset };
      }
      return result;
    }),
    [gf, options.limit, term]
  );
  const fetchChannelSearch = useCallback(
    (offset) => __async(void 0, null, function* () {
      const search = term.indexOf("@") === 0 ? term.split(" ")[0] : term;
      const result = yield gf.channels(search, { offset });
      return result.data;
    }),
    [gf, term]
  );
  useEffect4(() => {
    const fetchTrendingSearches = () => __async(void 0, null, function* () {
      let searches = [];
      try {
        const { data = [] } = yield request(`trending/searches?api_key=${apiKey}`);
        searches = data;
      } catch (error) {
        Logger2.warn(`Trending searches request failed: ${error}`);
      }
      setTrendingSearches(searches);
    });
    fetchTrendingSearches();
  }, [apiKey]);
  useEffect4(() => {
    const foundChannel = currentChannels.find(({ slug }) => term.indexOf(`@${slug} `) === 0);
    if (foundChannel) {
      _setActiveChannel(foundChannel);
    }
  }, [term, currentChannels, _setActiveChannel]);
  useEffect4(() => {
    if (shouldFetchChannels) {
      const fetchChannels = () => __async(void 0, null, function* () {
        const channels = yield fetchChannelSearch(0);
        setChannels(channels || emptyChannels);
      });
      if (!activeChannel && term.replace("@", "")) {
        fetchChannels();
      }
    }
  }, [term, activeChannel]);
  return /* @__PURE__ */ React15.createElement(
    SearchContext.Provider,
    {
      value: {
        activeChannel,
        setChannels,
        currentChannels,
        setActiveChannel,
        fetchChannelSearch,
        term,
        trendingSearches,
        setSearch,
        fetchGifs,
        fetchAnimatedText,
        searchKey,
        isFetching,
        isFocused
      }
    },
    /* @__PURE__ */ React15.createElement(_SearchContext.Provider, { value: { setIsFocused, _setSearch, _inputValOverride } }, /* @__PURE__ */ React15.createElement(
      Container7,
      {
        darkMode: theme == null ? void 0 : theme.darkMode,
        searchbarHeight: theme == null ? void 0 : theme.searchbarHeight,
        hideCancelButton: theme == null ? void 0 : theme.hideCancelButton,
        mobileSearchbarHeight: theme == null ? void 0 : theme.mobileSearchbarHeight,
        mobileMediaQuery: (theme == null ? void 0 : theme.mobileMediaQuery) || "max-width: 480px"
      },
      /* @__PURE__ */ React15.createElement(pingback_context_manager_default, { attributes: { layout_type: "SEARCH" } }, children)
    ))
  );
};
var context_default = SearchContextManager;

// src/components/search-bar/cancel-icon.tsx
var Icon = styled12.svg`
    position: relative;
    right: 10px;
    margin-left: 5px;
    cursor: pointer;
    display: var(${CssVars.cancelButtonDisplay});
`;
var CancelIcon = ({ width = 17, height = 17, setCleared }) => {
  const { term, setActiveChannel, activeChannel } = useContext3(SearchContext);
  return term || activeChannel ? /* @__PURE__ */ React16.createElement(
    Icon,
    {
      className: CancelIcon.className,
      width,
      height,
      viewBox: "0 0 17 17",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      onClick: (e) => {
        e.stopPropagation();
        e.preventDefault();
        setCleared(true);
        setActiveChannel(void 0);
      }
    },
    /* @__PURE__ */ React16.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", opacity: "0.582730817" }, /* @__PURE__ */ React16.createElement("g", { transform: "translate(-300.000000, -150.000000)", fill: "#8E8E93", fillRule: "nonzero" }, /* @__PURE__ */ React16.createElement("g", { transform: "translate(0.000000, 135.000000)" }, /* @__PURE__ */ React16.createElement("g", null, /* @__PURE__ */ React16.createElement("g", null, /* @__PURE__ */ React16.createElement("g", { transform: "translate(11.000000, 13.000000)" }, /* @__PURE__ */ React16.createElement("g", { transform: "translate(289.000000, 2.000000)" }, /* @__PURE__ */ React16.createElement(
      "path",
      {
        d: "M8.5,0 C3.805875,0 0,3.805875 0,8.5 C0,13.194125 3.805875,17 8.5,17 C13.194125,17 17,13.194125 17,8.5 C17,3.805875 13.194125,0 8.5,0 Z M9.50158333,8.5 C9.50158333,8.5 11.7250417,10.7234583 11.834125,10.8325417 C12.1110833,11.1095 12.1110833,11.557875 11.834125,11.834125 C11.5571667,12.1110833 11.1087917,12.1110833 10.8325417,11.834125 C10.7234583,11.72575 8.5,9.50158333 8.5,9.50158333 C8.5,9.50158333 6.27654167,11.7250417 6.16745833,11.834125 C5.8905,12.1110833 5.442125,12.1110833 5.165875,11.834125 C4.88891667,11.5571667 4.88891667,11.1087917 5.165875,10.8325417 C5.27425,10.7234583 7.49841667,8.5 7.49841667,8.5 C7.49841667,8.5 5.27495833,6.27654167 5.165875,6.16745833 C4.88891667,5.8905 4.88891667,5.442125 5.165875,5.165875 C5.44283333,4.88891667 5.89120833,4.88891667 6.16745833,5.165875 C6.27654167,5.27425 8.5,7.49841667 8.5,7.49841667 C8.5,7.49841667 10.7234583,5.27495833 10.8325417,5.165875 C11.1095,4.88891667 11.557875,4.88891667 11.834125,5.165875 C12.1110833,5.44283333 12.1110833,5.89120833 11.834125,6.16745833 C11.72575,6.27654167 9.50158333,8.5 9.50158333,8.5 Z",
        opacity: "0.75"
      }
    ))))))))
  ) : null;
};
CancelIcon.className = "giphy-search-bar-cancel";
var cancel_icon_default = CancelIcon;

// src/components/search-bar/search-bar-channel.tsx
import { giphyDarkCharcoal, giphyWhiteSmoke } from "@giphy/colors";
import React17, { useContext as useContext4 } from "react";
import styled13, { keyframes as keyframes2 } from "styled-components";
var channelMargin = 6;
var innerHeight = `calc(var(${CssVars.searchbarHeight}) - ${channelMargin * 2}px)`;
var animateAvatar = keyframes2`
to {
    width: ${innerHeight};
}
`;
var Avatar3 = styled13(avatar_default)`
    height: ${innerHeight};
    margin: 0;
    width: 0;
    animation: ${animateAvatar} 100ms ease-in-out forwards;
`;
var Username2 = styled13.div`
    background: var(${CssVars.bgColor2});
    display: flex;
    align-items: center;
    padding-left: ${channelMargin}px;
`;
var UsernamePill = styled13.div`
    background: ${giphyWhiteSmoke};
    display: flex;
    padding: 0 4px;
    color: ${giphyDarkCharcoal};
    font-family: interface, Helvetica Neue, helvetica, sans-serif;
    font-weight: 600;
    font-size: 12px;
    align-items: center;
    height: ${innerHeight};
    @media (max-width: 480px) {
        display: none;
    }
`;
var SearchBarChannel = ({ className = "" }) => {
  const { activeChannel } = useContext4(SearchContext);
  return activeChannel ? /* @__PURE__ */ React17.createElement(Username2, { className }, /* @__PURE__ */ React17.createElement(Avatar3, { user: activeChannel.user }), /* @__PURE__ */ React17.createElement(UsernamePill, { key: activeChannel.id }, /* @__PURE__ */ React17.createElement("div", null, "@", activeChannel.user.username), activeChannel.user.is_verified && /* @__PURE__ */ React17.createElement(verified_badge_default, { size: 14 }))) : null;
};
var search_bar_channel_default = SearchBarChannel;

// src/components/search-bar/search-button.tsx
import React19, { useContext as useContext5 } from "react";
import useThrottle from "react-use/lib/useThrottle";
import styled14, { keyframes as keyframes3 } from "styled-components";

// src/components/search-bar/search-icon.tsx
import React18 from "react";
var SearchIcon = ({ className = "" }) => /* @__PURE__ */ React18.createElement("svg", { viewBox: "0 0 30 30", version: "1.1", className }, /* @__PURE__ */ React18.createElement("defs", null, /* @__PURE__ */ React18.createElement(
  "path",
  {
    d: "M11.5482521,20.4090671 L4.24727698,28.2009189 C3.68084207,28.8054377 2.73159653,28.8363108 2.12707771,28.2698759 C1.5225589,27.703441 1.4916858,26.7541954 2.0581207,26.1496766 L9.40599838,18.3077689 C7.95982241,16.4371424 7.0978836,14.0789715 7.0978836,11.5181818 C7.0978836,5.44914339 11.9392549,0.518181818 17.9252787,0.518181818 C23.9113026,0.518181818 28.7526738,5.44914339 28.7526738,11.5181818 C28.7526738,17.5872202 23.9113026,22.5181818 17.9252787,22.5181818 C15.539851,22.5181818 13.3361963,21.7351359 11.5482521,20.4090671 Z M17.9252787,19.5181818 C22.242011,19.5181818 25.7526738,15.9425536 25.7526738,11.5181818 C25.7526738,7.09381 22.242011,3.51818182 17.9252787,3.51818182 C13.6085464,3.51818182 10.0978836,7.09381 10.0978836,11.5181818 C10.0978836,15.9425536 13.6085464,19.5181818 17.9252787,19.5181818 Z",
    id: "giphy-search-icon-path-1"
  }
)), /* @__PURE__ */ React18.createElement("g", { id: "search", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React18.createElement("g", { id: "icons/search" }, /* @__PURE__ */ React18.createElement("mask", { id: "giphy-search-icon-mask-2", fill: "white" }, /* @__PURE__ */ React18.createElement("use", { xlinkHref: "#giphy-search-icon-path-1" })), /* @__PURE__ */ React18.createElement("use", { id: "Mask", fill: "#FFFFFF", fillRule: "nonzero", xlinkHref: "#giphy-search-icon-path-1" }), /* @__PURE__ */ React18.createElement("g", { mask: "url(#giphy-search-icon-mask-2)" }, /* @__PURE__ */ React18.createElement("g", { transform: "translate(0.250000, 0.250000)" }, /* @__PURE__ */ React18.createElement("g", null))))));
var search_icon_default = SearchIcon;

// src/components/search-bar/search-button.tsx
var time = "2s";
var purp = "#9933FF";
var pink = "#FF6666";
var strongEasing = "cubic-bezier(0.920, 0.240, 0.185, 0.730)";
var searchFx = keyframes3`
    0% {
      transform: rotate(34deg) translate(-10px, 80px);
    };
    
    100% {
      transform: rotate(34deg) translate(-10px, -20px);
    }
`;
var plus = keyframes3`
    0% { 
      transform: translate(0px, 0px);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      transform: translate(10px, -17px);
      opacity: 0;
    }
`;
var gradientFade = keyframes3`
    0% {
      opacity: 0;
      transform: translateX(-400%);
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: translateX(0);
    }
`;
var Container8 = styled14.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: pointer;
    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
        display: none;
    }
    height: var(${CssVars.searchbarHeight});
    width: var(${CssVars.searchbarHeight});
`;
var GradientBox = styled14.div`
    position: absolute;
    height: 100%;
    width: 100%;
    background: linear-gradient(45deg, ${purp} 0%, ${pink} 100%);
    border-radius: 4px;
    overflow: hidden;
    &:before {
        animation: ${gradientFade} ${time} linear 0s infinite;
        background-image: linear-gradient(45deg, ${purp} 0%, ${pink} 50%, ${purp} 100%);
        background-size: 400%;
        background-position: 0% 100%;
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        width: 400%;
    }
`;
var Fx = styled14.div`
    width: 100%;
    height: 100%;
    position: absolute;
    overflow: hidden;
    &::after {
        content: '+';
        color: white;
        font-family: 'SS Standard';
        font-size: 8px;
        position: absolute;
        top: 65%;
        left: 66%;
        animation: ${plus} 1s ${strongEasing} 0s 1 forwards;
    }
`;
var Scanner = styled14.div`
    position: absolute;
    width: 200%;
    height: 20px;
    background: rgba(255, 255, 255, 0.5);
    transform: rotate(34deg) translate(-10px, -20px);
    animation: ${searchFx} 1s ${strongEasing} 0s 1;
    filter: blur(1px);
`;
var SearchIcon2 = styled14(search_icon_default)`
    z-index: 1;
    display: flex;
    width: 60%;
    height: 60%;
`;
var SearchButton = () => {
  const { isFetching } = useContext5(SearchContext);
  const throttledFetch = useThrottle(isFetching, 1e3);
  return /* @__PURE__ */ React19.createElement(Container8, null, /* @__PURE__ */ React19.createElement(GradientBox, null), /* @__PURE__ */ React19.createElement(SearchIcon2, null), throttledFetch && /* @__PURE__ */ React19.createElement(Fx, null, /* @__PURE__ */ React19.createElement(Scanner, null)));
};
var search_button_default = SearchButton;

// src/components/search-bar/index.tsx
function usePrevious(value) {
  const ref = useRef5(value);
  useEffect5(() => {
    ref.current = value;
  });
  return ref.current;
}
var SEARCH_DEBOUNCE = 500;
var Container9 = styled15.div`
    display: flex;
    background: white;
    align-items: center;
    border-radius: 4px;
    height: var(${CssVars.searchbarHeight});
    background: var(${CssVars.bgColor2});
`;
var Input = styled15.input`
    background: inherit;
    box-sizing: border-box;
    border: 0;
    appearance: none;
    font-weight: normal;
    font-family: interface, Helvetica Neue, helvetica, sans-serif;
    outline: 0;
    font-size: 15px;
    padding: 0 10px;
    border-radius: 0;
    text-overflow: ellipsis;
    color: var(${CssVars.fgColor});
    &::placeholder {
        color: ${giphyLightGrey2};
    }
    min-width: 150px;
    flex: 1;
    ${(props) => props.isUsernameSearch && css2`
            color: ${giphyIndigo};
        `}
`;
var SearchBar = ({
  className,
  placeholder: placeholder2 = `Search GIPHY`,
  clear = false,
  autoFocus,
  searchDebounce = SEARCH_DEBOUNCE,
  onEnter
}) => {
  const { activeChannel, setActiveChannel, term, setChannels } = useContext6(SearchContext);
  const { setIsFocused, _inputValOverride, _setSearch } = useContext6(_SearchContext);
  const [val, setVal] = useState3(term);
  useDebounce(() => _setSearch(val), searchDebounce, [val]);
  const inputRef = useRef5(null);
  const previousActiveChannel = usePrevious(activeChannel);
  const [isCleared, setCleared] = useState3(clear);
  useEffect5(() => {
    var _a;
    if (autoFocus) {
      (_a = inputRef.current) == null ? void 0 : _a.focus();
    }
  }, [autoFocus]);
  useEffect5(() => {
    var _a;
    if (activeChannel && !previousActiveChannel) {
      (_a = inputRef.current) == null ? void 0 : _a.focus();
      if (val === " ") {
        setVal("");
      } else {
        setVal(val.replace(/@?\w*\s?/, ""));
      }
    }
  }, [val, activeChannel, previousActiveChannel]);
  useEffect5(() => {
    setCleared(clear);
  }, [clear]);
  useEffect5(() => {
    setVal(_inputValOverride);
  }, [_inputValOverride, setVal]);
  const onKeyUp = (e) => {
    const key = e.keyCode || e.key;
    switch (key) {
      case 27:
      case `Escape`:
        setActiveChannel(void 0);
        setChannels([]);
        break;
      case 13:
      case `Enter`:
        onEnter == null ? void 0 : onEnter(val);
        break;
      default:
        break;
    }
  };
  const onKeyDown = (e) => {
    const key = e.keyCode || e.key;
    switch (key) {
      case 8:
      case "Backspace":
        if (val === "") {
          setActiveChannel(void 0);
          setChannels([]);
        }
        break;
      default:
        break;
    }
  };
  return /* @__PURE__ */ React20.createElement(Container9, { className: [SearchBar.className, className].join(" ") }, /* @__PURE__ */ React20.createElement(search_bar_channel_default, null), /* @__PURE__ */ React20.createElement(
    Input,
    {
      isUsernameSearch: term.indexOf("@") === 0,
      onChange: ({ target: { value } }) => {
        if (!isCleared || value !== "") {
          setCleared(false);
          setVal(value);
        }
      },
      onFocus: () => {
        setIsFocused(true);
      },
      onBlur: () => {
        setIsFocused(false);
      },
      value: isCleared ? "" : val,
      placeholder: activeChannel ? `Search ${activeChannel.display_name}` : placeholder2,
      autoCapitalize: "off",
      autoCorrect: "off",
      autoComplete: "off",
      ref: inputRef,
      onKeyUp,
      onKeyDown
    }
  ), /* @__PURE__ */ React20.createElement(cancel_icon_default, { setCleared: () => setVal("") }), /* @__PURE__ */ React20.createElement(search_button_default, null));
};
SearchBar.className = "giphy-search-bar";
var search_bar_default = SearchBar;

// src/components/search-bar/suggestion-bar/index.tsx
import React23, { useContext as useContext8 } from "react";
import styled17 from "styled-components";

// src/components/search-bar/suggestion-bar/pills.tsx
import { giphyDarkestGrey } from "@giphy/colors";
import React22, { useContext as useContext7 } from "react";
import styled16 from "styled-components";

// src/components/search-bar/suggestion-bar/trending-icon.tsx
import React21 from "react";
var TrendingIcon = ({ size = 18, className }) => /* @__PURE__ */ React21.createElement(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 18 16",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    className
  },
  /* @__PURE__ */ React21.createElement("g", { id: "trending", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React21.createElement("g", null, /* @__PURE__ */ React21.createElement(
    "rect",
    {
      id: "Rectangle",
      stroke: "#979797",
      fill: "#D8D8D8",
      opacity: "0",
      x: "0.5",
      y: "0.5",
      width: "17",
      height: "17"
    }
  ), /* @__PURE__ */ React21.createElement(
    "path",
    {
      d: "M12.6093329,3.12057664 L15.156896,3.12057664 L9.64199318,9.04253019 L6.88133868,6.8175119 C6.7544587,6.67603813 6.56616874,6.60087259 6.38404017,6.61897279 C6.2490402,6.63288422 6.11891631,6.69661171 6.02063992,6.79697337 C2.21226835,10.5943119 0.308082561,12.4929812 0.308082561,12.4929812 C0.308082561,12.4929812 0.527106106,12.8074292 0.710953088,13.0215425 C0.833517743,13.1642848 0.975497751,13.3098497 1.13689311,13.4582373 L6.47329888,8.13191205 L9.16381134,10.2953038 C9.40800276,10.5710787 9.68933701,10.7021044 10.019278,10.4570223 L16.0239805,4.04474473 C16.0239805,5.87956383 16.0239805,6.79697337 16.0239805,6.79697337 C16.0239805,6.79697337 16.4320205,6.79697337 17.2481004,6.79697337 L17.2481004,1.80604505 C14.1555887,1.80604505 12.6093329,1.80604505 12.6093329,1.80604505 C12.6093329,1.80604505 12.6093329,2.24422225 12.6093329,3.12057664 Z",
      id: "Shape",
      stroke: "#00CCFF",
      strokeWidth: "0.4",
      fill: "#00CCFF",
      fillRule: "nonzero",
      transform: "translate(8.778091, 7.632141) rotate(-2.000000) translate(-8.778091, -7.632141) "
    }
  )))
);
var trending_icon_default = TrendingIcon;

// src/components/search-bar/suggestion-bar/pills.tsx
var margin = 9;
var ChannelPillContainer = styled16.div`
    background: ${giphyDarkestGrey};
    display: flex;
    padding-right: 4px;
    align-items: center;
    margin-right: ${margin}px;
    cursor: pointer;
`;
var TrendingSearchPillContainer = styled16.div`
    background: ${giphyDarkestGrey};
    display: flex;
    padding: 14px;
    align-items: center;
    margin-right: ${margin}px;
    white-space: nowrap;
    cursor: pointer;
    font-style: italic;
    border-radius: 20px;
`;
var Avatar4 = styled16(avatar_default)`
    height: var(${CssVars.searchbarHeight});
    width: var(${CssVars.searchbarHeight});
`;
var TrendingIcon2 = styled16(trending_icon_default)`
    margin-right: 2px;
`;
var ChannelPill = ({ channel }) => {
  const { setActiveChannel } = useContext7(SearchContext);
  return /* @__PURE__ */ React22.createElement(ChannelPillContainer, { key: channel.id, onClick: () => setActiveChannel(channel) }, /* @__PURE__ */ React22.createElement(Avatar4, { user: channel.user }), /* @__PURE__ */ React22.createElement("div", null, "@", channel.user.username), channel.user.is_verified && /* @__PURE__ */ React22.createElement(verified_badge_default, { size: 14 }));
};
var TrendingSearchPill = ({ trendingSearch }) => {
  const { setSearch } = useContext7(SearchContext);
  return /* @__PURE__ */ React22.createElement(TrendingSearchPillContainer, { key: trendingSearch, onClick: () => setSearch(trendingSearch) }, /* @__PURE__ */ React22.createElement(TrendingIcon2, { size: 16 }), trendingSearch);
};

// src/components/search-bar/suggestion-bar/index.tsx
var Container10 = styled17.div`
    display: flex;
    color: white;
    flex-direction: row;
    font-family: 'interface';
    font-weight: 600;
    font-size: 14px;
    -webkit-overflow-scrolling: touch;
    overflow-x: auto;
    overflow-y: hidden;
    padding-bottom: 10px;
    height: var(${CssVars.searchbarHeight});
`;
var SuggestionBar = () => {
  const { trendingSearches, currentChannels } = useContext8(SearchContext);
  return /* @__PURE__ */ React23.createElement(Container10, { className: SuggestionBar.className }, currentChannels.length > 0 ? currentChannels.map((channel) => /* @__PURE__ */ React23.createElement(ChannelPill, { key: channel.id, channel })) : trendingSearches.map((trendingSearch) => /* @__PURE__ */ React23.createElement(TrendingSearchPill, { key: trendingSearch, trendingSearch })));
};
SuggestionBar.className = "giphy-suggestion-bar";
var suggestion_bar_default = SuggestionBar;

// src/components/video/index.tsx
import { getGifHeight as getGifHeight4, Logger as Logger3 } from "@giphy/js-util";
import React29, { useCallback as useCallback3, useEffect as useEffect7, useState as useState5 } from "react";
import useTimeoutFn from "react-use/lib/useTimeoutFn";
import styled20 from "styled-components";

// src/components/video/attribution.tsx
import React25 from "react";
import styled18 from "styled-components";

// src/components/video/clips-branding.tsx
import React24 from "react";
var GIPHYClips = ({ onClick }) => /* @__PURE__ */ React24.createElement("svg", { width: "66px", height: "13px", viewBox: "0 0 66 13", onClick }, /* @__PURE__ */ React24.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React24.createElement("g", { transform: "translate(-1060.000000, -462.000000)", fill: "#FFFFFF", fillRule: "nonzero" }, /* @__PURE__ */ React24.createElement("g", { transform: "translate(931.000000, 286.375671)" }, /* @__PURE__ */ React24.createElement("g", { transform: "translate(86.000000, 136.124329)" }, /* @__PURE__ */ React24.createElement(
  "path",
  {
    d: "M47.968,49.1962322 C49.588,49.1962322 51.052,48.6202322 51.58,47.5522322 L51.58,43.8202322 L47.476,43.8202322 L47.476,45.6802322 L49.6,45.6802322 L49.6,46.7602322 C49.12,47.1082322 48.424,47.1922322 47.98,47.1922322 C46.288,47.1922322 45.724,45.8602322 45.724,44.7802322 C45.724,43.1362322 46.612,42.3202322 47.98,42.3202322 C48.544,42.3202322 49.288,42.4762322 49.9,43.0522322 L51.28,41.6842322 C50.176,40.5682322 49.144,40.3282322 47.98,40.3282322 C44.824,40.3282322 43.384,42.5842322 43.384,44.7802322 C43.384,46.9762322 44.644,49.1962322 47.968,49.1962322 Z M54.928,48.9682322 L54.928,40.5682322 L52.564,40.5682322 L52.564,48.9682322 L54.928,48.9682322 Z M58.648,48.9682322 L58.648,46.7002322 L60.352,46.7002322 C62.596,46.6762322 63.724,45.3442322 63.724,43.6282322 C63.724,41.9842322 62.608,40.5682322 60.352,40.5682322 L56.272,40.5682322 L56.272,48.9682322 L58.648,48.9682322 Z M60.352,44.6962322 L58.648,44.6962322 L58.648,42.6082322 L60.352,42.6082322 C61,42.6082322 61.348,43.1122322 61.348,43.6642322 C61.348,44.2162322 61.012,44.6962322 60.352,44.6962322 Z M66.796,48.9802322 L66.796,45.8002322 L69.82,45.8002322 L69.82,48.9802322 L72.172,48.9802322 L72.172,40.5802322 L69.82,40.5802322 L69.82,43.7722322 L66.796,43.7722322 L66.796,40.5802322 L64.42,40.5802322 L64.42,48.9802322 L66.796,48.9802322 Z M78.16,48.9682322 L78.16,45.6202322 L81.496,40.6762322 L81.496,40.5682322 L78.82,40.5682322 L77.008,43.4482322 L75.268,40.5682322 L72.592,40.5682322 L72.592,40.6642322 L75.784,45.6202322 L75.784,48.9682322 L78.16,48.9682322 Z M87.796,49.1362322 C88.972,49.1362322 90.088,48.7402322 90.952,47.8882322 L90.028,46.9642322 C89.44,47.5522322 88.576,47.8762322 87.796,47.8762322 C85.624,47.8762322 84.712,46.3522322 84.7,44.8162322 C84.688,43.2682322 85.66,41.6962322 87.796,41.6962322 C88.576,41.6962322 89.368,41.9722322 89.968,42.5602322 L90.868,41.6962322 C90.016,40.8442322 88.924,40.4242322 87.796,40.4242322 C84.796,40.4242322 83.356,42.6202322 83.3679256,44.8282322 C83.38,47.0362322 84.748,49.1362322 87.796,49.1362322 Z M93.028,48.9682322 L93.028,40.5802322 L91.792,40.5802322 L91.792,48.9682322 L93.028,48.9682322 Z M94.252,41.3122322 C94.252,42.3322322 95.788,42.3322322 95.788,41.3122322 C95.788,40.3042322 94.252,40.3042322 94.252,41.3122322 Z M95.632,48.9682322 L95.632,43.0282322 L94.396,43.0282322 L94.396,48.9682322 L95.632,48.9682322 Z M98.188,51.7162322 L98.188,48.1042322 C98.632,48.8362322 99.556,49.1002322 100.276,49.1002322 C102.112,49.1002322 103.264,47.8042322 103.264,46.0162322 C103.264,44.2282322 102.04,42.9442322 100.276,42.9322322 C99.484,42.9322322 98.644,43.2922322 98.188,44.0122322 L98.116,43.0522322 L96.952,43.0522322 L96.952,51.7162322 L98.188,51.7162322 Z M100.156,47.9002322 C99.076,47.9002322 98.296,47.0722322 98.296,46.0162322 C98.296,44.9602322 99.016,44.1322322 100.156,44.1322322 C101.284,44.1322322 102.028,44.9002322 102.028,46.0162322 C102.028,47.1202322 101.236,47.9002322 100.156,47.9002322 Z M106.456,49.1482322 C107.992,49.1482322 108.964,48.3802322 108.976,47.2762322 C108.988,45.7522322 107.56,45.5122322 106.468,45.4162322 C105.712,45.3442322 105.196,45.1522322 105.184,44.6602322 C105.184,44.1922322 105.688,43.9402322 106.444,43.9522322 C107.032,43.9522322 107.536,44.0722322 108.004,44.5042322 L108.7,43.6882322 C108.04,43.1002322 107.332,42.8962322 106.42,42.8962322 C105.316,42.8962322 103.96,43.3882322 103.96,44.6962322 C103.972,46.0042322 105.256,46.3642322 106.372,46.4722322 C107.248,46.5562322 107.752,46.7602322 107.74,47.2882322 C107.728,47.8402322 107.068,48.0562322 106.48,48.0562322 C105.784,48.0442322 104.956,47.7922322 104.404,47.1802322 L103.756,48.0562322 C104.536,48.9322322 105.496,49.1482322 106.456,49.1482322 Z",
    id: "GIPHYClips"
  }
))))));
var clips_branding_default = GIPHYClips;

// src/components/video/attribution.tsx
var Container11 = styled18.div`
    display: flex;
    align-items: center;
    font-family: interface, helvetica, arial;
    cursor: pointer;
`;
var Avatar5 = styled18(avatar_default)`
    flex-shrink: 0;
`;
var Right = styled18.div`
    display: flex;
    flex-direction: column;
`;
var Attribution3 = ({ gif, className, onClick }) => {
  const { user } = gif;
  if (!(user == null ? void 0 : user.username) && !(user == null ? void 0 : user.display_name)) {
    return null;
  }
  return /* @__PURE__ */ React25.createElement(
    Container11,
    {
      className: [Attribution3.className, className].join(" "),
      onClick: (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (onClick) {
          onClick(gif);
        } else {
          const url = user.profile_url;
          if (url)
            window.open(url, "_blank");
        }
      }
    },
    /* @__PURE__ */ React25.createElement(Avatar5, { user }),
    /* @__PURE__ */ React25.createElement(Right, null, /* @__PURE__ */ React25.createElement(
      clips_branding_default,
      {
        onClick: (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (onClick) {
            onClick(gif);
          } else if (gif.url) {
            window.open(gif.url, "_blank");
          }
        }
      }
    ), /* @__PURE__ */ React25.createElement(user_default, { user }))
  );
};
Attribution3.className = "giphy-attribution";
var attribution_default2 = Attribution3;

// src/components/video/controls/volume.tsx
import React26 from "react";
var VolumeSize = 25;
var VolumeOnIcon = ({ size = VolumeSize, onClick = () => {
} }) => /* @__PURE__ */ React26.createElement("svg", { width: size, height: size, viewBox: "0 0 26 23", onClick }, /* @__PURE__ */ React26.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React26.createElement("g", { transform: "translate(1.000000, 0.000000)", fill: "#FFF", fillRule: "nonzero" }, /* @__PURE__ */ React26.createElement("path", { d: "M11.9625091,0.572584405 L11.9625091,22.2272644 C11.9625091,22.4856644 11.8466091,22.6635044 11.6151891,22.7611644 C11.3480491,22.8413444 11.1390491,22.7968844 10.9878091,22.6277844 L4.8732291,15.9143244 L0.573909096,15.9143244 C0.413549096,15.9143244 0.277509096,15.8588444 0.166549096,15.7475044 C0.0573082348,15.6406091 -0.00292164572,15.4933347 -1.77635684e-15,15.3405244 L-1.77635684e-15,7.45058441 C-1.77635684e-15,7.29022441 0.0555890961,7.15456441 0.167309096,7.04322441 C0.278269096,6.93226441 0.414309096,6.87640441 0.573909096,6.87640441 L4.8732291,6.87640441 L10.9874291,0.172064405 C11.1390491,0.00296440549 11.3484291,-0.0414955945 11.6151891,0.0386844055 C11.8466091,0.136344405 11.9621291,0.314564405 11.9621291,0.572584405 L11.9625091,0.572584405 Z" }), /* @__PURE__ */ React26.createElement("path", { d: "M15.7579491,16.0914044 L14.6798891,13.6594044 C15.5739159,13.2635547 16.1503537,12.3776671 16.1501091,11.3999244 C16.150386,10.4242626 15.5763999,9.53983269 14.6852091,9.14272441 L15.7697291,6.71376441 C17.6193585,7.53872062 18.810518,9.37466359 18.8101092,11.3999244 C18.8105521,13.4298903 17.6139475,15.2691931 15.7579491,16.0914044 L15.7579491,16.0914044 Z" }), /* @__PURE__ */ React26.createElement("path", { d: "M18.3647491,20.2619044 L17.2863091,17.8299044 C19.8302925,16.7031661 21.4705725,14.1822599 21.4701091,11.3999244 C21.4701091,8.59818441 19.8167291,6.09892441 17.3022691,4.97678441 L18.3864091,2.54782441 C21.8804724,4.10607079 24.1307363,7.57414217 24.1301093,11.3999244 C24.1308375,15.2343934 21.8705556,18.7086904 18.3647491,20.2619044 Z" }))));
var VolumeOffIcon = ({ size = VolumeSize, onClick = () => {
} }) => /* @__PURE__ */ React26.createElement(
  "svg",
  {
    onClick,
    height: size,
    width: size,
    viewBox: "0 0 26 23",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React26.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React26.createElement("g", { id: "Group", transform: "translate(1.000000, 0.000000)", fill: "#FFFFFF", fillRule: "nonzero" }, /* @__PURE__ */ React26.createElement(
    "path",
    {
      d: "M11.9625091,0.572584405 L11.9625091,22.2272644 C11.9625091,22.4856644 11.8466091,22.6635044 11.6151891,22.7611644 C11.3480491,22.8413444 11.1390491,22.7968844 10.9878091,22.6277844 L4.8732291,15.9143244 L0.573909096,15.9143244 C0.413549096,15.9143244 0.277509096,15.8588444 0.166549096,15.7475044 C0.0573082348,15.6406091 -0.00292164572,15.4933347 0,15.3405244 L0,7.45058441 C0,7.29022441 0.0555890961,7.15456441 0.167309096,7.04322441 C0.278269096,6.93226441 0.414309096,6.87640441 0.573909096,6.87640441 L4.8732291,6.87640441 L10.9874291,0.172064405 C11.1390491,0.00296440549 11.3484291,-0.0414955945 11.6151891,0.0386844055 C11.8466091,0.136344405 11.9621291,0.314564405 11.9621291,0.572584405 L11.9625091,0.572584405 Z",
      id: "Path"
    }
  )), /* @__PURE__ */ React26.createElement("g", { id: "Group", transform: "translate(14.887009, 6.947630)", fill: "#FFFFFF", fillRule: "nonzero" }, /* @__PURE__ */ React26.createElement(
    "path",
    {
      d: "M7.88199149,6.27905236 C7.94693088,6.35707599 7.94693088,6.47033309 7.88199149,6.54835671 L6.54835671,7.88199149 C6.47033309,7.94693088 6.35707599,7.94693088 6.27905236,7.88199149 L3.96534802,5.56828715 L1.65164367,7.88199149 C1.57362004,7.94693088 1.46036294,7.94693088 1.38233932,7.88199149 L0.0487045381,6.54835671 C-0.016234846,6.47033309 -0.016234846,6.35707599 0.0487045381,6.27905236 L2.36240889,3.96534802 L0.0487045381,1.65164367 C-0.016234846,1.57362004 -0.016234846,1.46036294 0.0487045381,1.38233932 L1.38233932,0.0487045381 C1.46036294,-0.016234846 1.57362004,-0.016234846 1.65164367,0.0487045381 L3.96534802,2.36240889 L6.27905236,0.0487045381 C6.35707599,-0.016234846 6.47033309,-0.016234846 6.54835671,0.0487045381 L7.88199149,1.38233932 C7.94693088,1.46036294 7.94693088,1.57362004 7.88199149,1.65164367 L5.56828715,3.96534802 L7.88199149,6.27905236 Z",
      id: "Shape"
    }
  )))
);

// src/components/video/progress-bar.tsx
import { giphyWhite as giphyWhite2 } from "@giphy/colors";
import React27 from "react";
import useRaf from "react-use/lib/useRaf";
import styled19 from "styled-components";
var Bar = styled19.div`
    background: ${giphyWhite2};
    height: ${(props) => props.barHeight}px;
    position: absolute;
    width: 5px;
    bottom: 0;
    left: 0;
    opacity: 0.95;
`;
var ProgressBar = ({ videoEl }) => {
  useRaf(2147483647, 100);
  const time2 = (videoEl == null ? void 0 : videoEl.currentTime) || 0;
  const duration = (videoEl == null ? void 0 : videoEl.duration) || 0;
  const val = time2 / duration;
  let percentage = Math.round(val * 100);
  let barHeight = 5;
  if ((videoEl == null ? void 0 : videoEl.height) < 200) {
    barHeight = 3;
  } else if ((videoEl == null ? void 0 : videoEl.height) < 300) {
    barHeight = 4;
  }
  percentage = duration < 10 && percentage > 98 ? 100 : percentage;
  return /* @__PURE__ */ React27.createElement(Bar, { style: { width: `${percentage}%` }, barHeight, className: "hide-in-percy" });
};
var progress_bar_default = ProgressBar;

// src/components/video/video.tsx
import { pingback as pingback2 } from "@giphy/js-analytics";
import { getBestVideo, getGifHeight as getGifHeight3 } from "@giphy/js-util";
import React28, { useCallback as useCallback2, useEffect as useEffect6, useRef as useRef6, useState as useState4 } from "react";

// src/components/video/util.ts
var getErrorMessage = (code, src = "") => {
  switch (code) {
    case 1:
      return "Aborted. The fetching process for the media resource was aborted by the user agent at the user's request.";
    case 2:
      return "Network Error. A network error of some description caused the user agent to stop fetching the media resource, after the resource was established to be usable.";
    case 3:
      return "Decode Error. An error of some description occurred while decoding the media resource, after the resource was established to be usable.";
    case 4:
      return `Can not play a video of type "${src.split(".").pop()}" on this platform.`;
    default:
      return "";
  }
};
var shouldFireQuartile = (quartile, playhead, duration, quartilesFired, loopNumber) => {
  const currentQuartile = loopNumber + quartile;
  if (!quartilesFired.has(currentQuartile) && duration > 0 && playhead > duration * quartile) {
    quartilesFired.add(currentQuartile);
    return true;
  }
  return false;
};

// src/components/video/video.tsx
var quartileEvents = [0.25, 0.5, 0.75];
var videoClassName = "giphy-video";
var Network = {
  // The element has not yet been initialized. All attributes are in their initial states.
  EMPTY: 0,
  // The element's resource selection algorithm is active and has selected a resource, but it is not actually using the network at this time.
  IDLE: 1,
  // The user agent is actively trying to download data.
  LOADING: 2,
  // The element's resource selection algorithm is active, but it has not yet found a resource to use.
  NO_SOURCE: 3
};
var Video = ({
  muted,
  ccEnabled = false,
  ccLanguage = "en",
  loop = true,
  onStateChange,
  onTimeUpdate,
  onCanPlay,
  onFirstPlay,
  onWaiting,
  onMuted,
  onError,
  onEnded,
  onLoop,
  onQuartile,
  onEndFullscreen,
  setVideoEl,
  gif,
  width,
  height: height_,
  volume = 0.7,
  className = videoClassName
}) => {
  var _a, _b, _c;
  const height = height_ || getGifHeight3(gif, width);
  const [media, setMedia] = useState4(getBestVideo(gif.video, width, height));
  const seek = useRef6(0);
  if (!media) {
    console.warn(`GiphyJS No video content for id: ${gif.id}`);
  }
  const mountTime = useRef6(Date.now());
  const hasPlayingFired = useRef6(false);
  const loopNumber = useRef6(0);
  const waitingCount = useRef6(0);
  const quartilesFired = useRef6(/* @__PURE__ */ new Set());
  useEffect6(() => {
    mountTime.current = Date.now();
    hasPlayingFired.current = false;
    loopNumber.current = 1;
    waitingCount.current = 0;
    quartilesFired.current = /* @__PURE__ */ new Set();
  }, [gif.id]);
  const videoEl = useRef6(null);
  useEffect6(() => {
    const newMedia = getBestVideo(gif.video, width, height);
    if (videoEl.current && (media == null ? void 0 : media.url) && newMedia.url !== media.url) {
      if (media.url.indexOf(String(gif.id)) !== -1) {
        seek.current = videoEl.current.currentTime;
      }
      setMedia(newMedia);
    }
  }, [width, height_, gif.video, height, media == null ? void 0 : media.url, gif.id]);
  useEffect6(() => {
    if (videoEl.current && (media == null ? void 0 : media.url) && seek.current) {
      videoEl.current.currentTime = seek.current;
      seek.current = 0;
    }
  }, [media == null ? void 0 : media.url, seek]);
  const _onError = useCallback2(() => {
    var _a2;
    const el = videoEl.current;
    const code = (_a2 = el == null ? void 0 : el.error) == null ? void 0 : _a2.code;
    if (code && (el == null ? void 0 : el.src)) {
      const message = getErrorMessage(code, el == null ? void 0 : el.src);
      console.error(message);
      onError == null ? void 0 : onError(code);
    }
  }, [onError]);
  const _onPlaying = useCallback2(() => {
    onStateChange == null ? void 0 : onStateChange("playing");
    if (!hasPlayingFired.current) {
      hasPlayingFired.current = true;
      if (gif.analytics_response_payload) {
        pingback2({ actionType: "START", analyticsResponsePayload: gif.analytics_response_payload });
      }
      onFirstPlay == null ? void 0 : onFirstPlay(Date.now() - mountTime.current);
    }
  }, [onFirstPlay, onStateChange, gif]);
  const _onPaused = useCallback2(() => onStateChange == null ? void 0 : onStateChange("paused"), [onStateChange]);
  const _onTimeUpdate = useCallback2(() => {
    const el = videoEl.current;
    if (el) {
      const playhead = el.currentTime;
      quartileEvents.some((q) => {
        if (shouldFireQuartile(q, playhead, el.duration, quartilesFired.current, loopNumber.current)) {
          onQuartile == null ? void 0 : onQuartile(q);
          return true;
        }
        return false;
      });
      onTimeUpdate == null ? void 0 : onTimeUpdate(playhead || 0);
    }
  }, [onQuartile, onTimeUpdate]);
  const _onCanPlay = useCallback2(() => onCanPlay == null ? void 0 : onCanPlay(), [onCanPlay]);
  const _onWaiting = useCallback2(() => {
    const el = videoEl.current;
    if ((el == null ? void 0 : el.currentTime) !== 0 && (el == null ? void 0 : el.networkState) !== Network.IDLE) {
      onWaiting == null ? void 0 : onWaiting(++waitingCount.current);
    }
  }, [onWaiting]);
  const _onEnded = useCallback2(() => {
    if (!hasPlayingFired.current) {
      return;
    }
    if (loop && videoEl.current) {
      videoEl.current.play();
    }
    onLoop == null ? void 0 : onLoop(loopNumber.current);
    loopNumber.current = loopNumber.current + 1;
    onEnded == null ? void 0 : onEnded();
  }, [onEnded, loop, onLoop]);
  const _onEndFullscreen = useCallback2(() => onEndFullscreen == null ? void 0 : onEndFullscreen(), [onEndFullscreen]);
  const tryAutoPlayWithSound = useCallback2(
    (videoEl2) => __async(void 0, null, function* () {
      if (videoEl2) {
        const promisePlay = videoEl2.play();
        if (promisePlay !== void 0) {
          try {
            yield promisePlay;
            onMuted == null ? void 0 : onMuted(false);
          } catch (error) {
            videoEl2.muted = true;
            onMuted == null ? void 0 : onMuted(true);
            videoEl2.play();
          }
        }
      }
    }),
    [onMuted]
  );
  useEffect6(() => {
    const el = videoEl.current;
    if (el) {
      tryAutoPlayWithSound(el);
      setVideoEl == null ? void 0 : setVideoEl(el);
      if (!isNaN(volume)) {
        el.volume = volume;
      }
    }
  }, []);
  useEffect6(() => {
    const el = videoEl.current;
    if (el) {
      el.addEventListener("play", _onPlaying);
      el.addEventListener("pause", _onPaused);
      el.addEventListener("error", _onError);
      el.addEventListener("timeupdate", _onTimeUpdate);
      el.addEventListener("canplay", _onCanPlay);
      el.addEventListener("ended", _onEnded);
      el.addEventListener("waiting", _onWaiting);
      el.addEventListener("webkitendfullscreen", _onEndFullscreen);
    }
    return () => {
      if (el) {
        el.removeEventListener("play", _onPlaying);
        el.removeEventListener("pause", _onPaused);
        el.removeEventListener("error", _onError);
        el.removeEventListener("timeupdate", _onTimeUpdate);
        el.removeEventListener("canplay", _onCanPlay);
        el.removeEventListener("ended", _onEnded);
        el.removeEventListener("waiting", _onWaiting);
        el.removeEventListener("webkitendfullscreen", _onEndFullscreen);
      }
    };
  }, [_onPlaying, _onPaused, _onError, _onTimeUpdate, _onCanPlay, _onEnded, _onWaiting, _onEndFullscreen]);
  const captionSrc = (_c = (_b = (_a = gif.video) == null ? void 0 : _a.captions) == null ? void 0 : _b[ccLanguage]) == null ? void 0 : _c.vtt;
  return (media == null ? void 0 : media.url) ? /* @__PURE__ */ React28.createElement(
    "video",
    {
      crossOrigin: "anonymous",
      draggable: true,
      className,
      width,
      height,
      muted,
      autoPlay: true,
      playsInline: true,
      ref: videoEl,
      src: media == null ? void 0 : media.url,
      "data-giphy-id": gif.id
    },
    ccEnabled && captionSrc && /* @__PURE__ */ React28.createElement("track", { label: "English", kind: "subtitles", srcLang: ccLanguage, src: captionSrc, default: true })
  ) : null;
};
Video.className = videoClassName;
var video_default = Video;

// src/components/video/index.tsx
var Container12 = styled20.div`
    position: relative;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: black;
    font-family: interface, helvetica, arial;
    -webkit-font-smoothing: antialiased;
`;
var Volume = styled20.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: pointer;
`;
var Controls = styled20.div`
    position: absolute;
    top: 10px;
    right: 10px;
    left: 10px;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    opacity: ${(props) => props.isHovered ? 1 : 0};
    transition: opacity ease-out 250ms;
    align-items: flex-start;
`;
var Title = styled20.div`
    font-size: 22px;
    color: white;
    margin-bottom: 5px;
    font-weight: bold;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    user-select: none;
    cursor: pointer;
`;
var TitleContainer = styled20.div`
    position: relative;
    min-width: 0;
`;
var Gradient = styled20.div`
    &:before {
        background: linear-gradient(rgba(18, 18, 18, 0.6), rgba(0, 0, 0, 0));
        content: '';
        height: ${(props) => props.isLargePlayer ? 125 : 75}px;
        left: 0;
        pointer-events: none;
        position: absolute;
        top: 0;
        width: 100%;
    }
    &:after {
        background: linear-gradient(rgba(0, 0, 0, 0), rgba(18, 18, 18, 0.6));
        content: '';
        height: ${(props) => props.isLargePlayer ? 125 : 75}px;
        left: 0;
        pointer-events: none;
        position: absolute;
        bottom: 0;
        width: 100%;
    }
`;
var LARGE_PLAYER_HEIGHT = 300;
var AUTO_HIDE_TIMEOUT = 4e3;
var VideoPlayer = (props) => {
  const {
    width,
    hideMute,
    hideAttribution,
    hideProgressBar,
    className,
    persistentControls,
    gif,
    overlay: Overlay
  } = props;
  const [isHovered, setIsHovered] = useState5(false);
  const [videoEl, _setVideoEl] = useState5(null);
  const [muted, setMuted] = useState5(props.muted);
  const [mutedByBrowser, setMutedByBrowser] = useState5(false);
  const { setVideoEl, onMuted, onUserMuted } = props;
  const height = props.height || getGifHeight4(gif, width);
  const [, cancelHideTimeout, resetHideTimeout] = useTimeoutFn(() => {
    setIsHovered(false);
  }, AUTO_HIDE_TIMEOUT);
  const combinedOnMuted = useCallback3(
    (args) => {
      onMuted == null ? void 0 : onMuted(args);
      setMutedByBrowser(args);
    },
    [setMutedByBrowser, onMuted]
  );
  const combinedSetVideoEl = useCallback3(
    (args) => {
      setVideoEl == null ? void 0 : setVideoEl(args);
      _setVideoEl(args);
    },
    [setVideoEl, _setVideoEl]
  );
  const toggleMute = () => {
    if (mutedByBrowser) {
      setMutedByBrowser(false);
      setMuted(false);
    } else {
      setMuted(!muted);
    }
  };
  useEffect7(() => {
    setMuted(props.muted);
  }, [props.muted]);
  const showControls = persistentControls || isHovered;
  const isLargePlayer = height >= LARGE_PLAYER_HEIGHT;
  useEffect7(() => {
    if (showControls) {
      resetHideTimeout();
    } else {
      cancelHideTimeout();
    }
    return () => cancelHideTimeout();
  }, [showControls, cancelHideTimeout, resetHideTimeout]);
  return /* @__PURE__ */ React29.createElement(
    Container12,
    {
      className,
      style: { width, height },
      onMouseOver: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false),
      onMouseMove: () => {
        setIsHovered(true);
        resetHideTimeout();
      },
      onClick: (e) => {
        onUserMuted == null ? void 0 : onUserMuted(!(muted || mutedByBrowser));
        videoEl == null ? void 0 : videoEl.play();
        e.preventDefault();
        toggleMute();
      }
    },
    /* @__PURE__ */ React29.createElement(video_default, __spreadProps(__spreadValues({}, props), { onMuted: combinedOnMuted, setVideoEl: combinedSetVideoEl, muted })),
    showControls && /* @__PURE__ */ React29.createElement(Gradient, { isLargePlayer }),
    /* @__PURE__ */ React29.createElement(Controls, { isHovered: showControls }, /* @__PURE__ */ React29.createElement(TitleContainer, null, isLargePlayer && /* @__PURE__ */ React29.createElement(
      Title,
      {
        onClick: (e) => {
          e.preventDefault();
          e.stopPropagation();
          window.open(gif.url, "_blank");
        }
      },
      gif.title
    ), videoEl && !hideAttribution ? /* @__PURE__ */ React29.createElement(attribution_default2, { gif }) : null), !hideMute && /* @__PURE__ */ React29.createElement(Volume, null, muted || mutedByBrowser ? /* @__PURE__ */ React29.createElement(VolumeOffIcon, null) : /* @__PURE__ */ React29.createElement(VolumeOnIcon, null))),
    showControls && !hideProgressBar && videoEl ? /* @__PURE__ */ React29.createElement(progress_bar_default, { videoEl }) : null,
    Overlay && /* @__PURE__ */ React29.createElement(Overlay, { gif, isHovered, width, height })
  );
};
var VideoWrapper = (props) => {
  if (props.overlay && !props.controls) {
    console.warn(`${Logger3.PREFIX}: Overlays only work when controls are enabled`);
  }
  return props.controls ? /* @__PURE__ */ React29.createElement(VideoPlayer, __spreadValues({}, props)) : /* @__PURE__ */ React29.createElement(video_default, __spreadValues({}, props));
};
var video_default2 = VideoWrapper;

// src/components/video/controls/play-pause.tsx
import React30 from "react";
var PlayPauseSize = 25;
var PlayIcon = ({ size = PlayPauseSize }) => /* @__PURE__ */ React30.createElement("svg", { height: size, viewBox: "15.39 10.84 18.21 24", width: size, xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React30.createElement("g", { fillRule: "evenodd", fill: "none" }, /* @__PURE__ */ React30.createElement(
  "path",
  {
    fill: "#fff",
    d: "M15.836 10.842c.135 0 .27.04.404.12L33.444 22.86c.107.087.161.19.161.311 0 .12-.054.224-.161.31-11.649 7.575-17.528 11.362-17.64 11.362a.632.632 0 0 1-.41-.13l.025-23.75a.804.804 0 0 1 .417-.12z"
  }
)));
var PauseIcon = ({ size = PlayPauseSize }) => /* @__PURE__ */ React30.createElement("svg", { height: size, viewBox: "0.92 0.92 23.54 24", width: size, xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React30.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React30.createElement("g", { id: "Group", transform: "translate(0.916948, 0.916948)", fill: "#FFFFFF", fillRule: "nonzero" }, /* @__PURE__ */ React30.createElement(
  "path",
  {
    d: "M0,23.2 L0,0.8 C0,0.3581722 0.3581722,0 0.8,0 L8.2,0 C8.64182776,0 9,0.3581722 9,0.8 L9,23.2 C9,23.6418278 8.64182776,24 8.2,24 L0.8,24 C0.3581722,24 0,23.6418278 0,23.2 Z",
    id: "Path"
  }
), /* @__PURE__ */ React30.createElement(
  "path",
  {
    d: "M14.5408163,23.2 L14.5408163,0.8 C14.5408163,0.3581722 14.8989886,0 15.3408163,0 L22.7408163,0 C23.1826441,0 23.5408163,0.3581722 23.5408163,0.8 L23.5408163,23.2 C23.5408163,23.6418278 23.1826441,24 22.7408163,24 L15.3408163,24 C14.8989886,24 14.5408163,23.6418278 14.5408163,23.2 Z",
    id: "Path"
  }
))));

// src/components/video/video-overlay.tsx
import React31, { useEffect as useEffect8, useState as useState6 } from "react";
import styled21 from "styled-components";
var VideoContainer = styled21.div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
`;
var VideoStyled = styled21(video_default2)`
    height: 100%;
    display: inline-block;
    object-fit: fill;
    pointer-events: none;
    background: rgb(0, 0, 0, 0);
`;
var Button = styled21.div`
    position: absolute;
    top: 6px;
    right: 6px;
    cursor: pointer;
    opacity: ${(props) => props.isHovered ? 1 : 0.8};
    transition: opacity ease-out 800ms;
`;
var speakerClassName = "giphy-video-overlay-button";
var VolumeButton = ({ muted, toggleMute, mutedByBrowser, isHovered }) => /* @__PURE__ */ React31.createElement(
  Button,
  {
    className: speakerClassName,
    onClick: (e) => {
      e.preventDefault();
      e.stopPropagation();
      toggleMute();
    },
    isHovered
  },
  muted || mutedByBrowser || !isHovered ? /* @__PURE__ */ React31.createElement(VolumeOffIcon, null) : /* @__PURE__ */ React31.createElement(VolumeOnIcon, null)
);
var VideoOverlay = ({
  gif,
  isHovered,
  hideMuteButton,
  width,
  height,
  className,
  muted: userPrefMuted = false,
  onUserMuted
}) => {
  const [muted, setMuted] = useState6(userPrefMuted);
  const [mutedByBrowser, setMutedByBrowser] = useState6(false);
  const toggleMute = () => {
    if (mutedByBrowser) {
      setMutedByBrowser(false);
      setMuted(false);
    } else {
      onUserMuted == null ? void 0 : onUserMuted(!muted);
      setMuted(!muted);
    }
  };
  useEffect8(() => {
    setMuted(userPrefMuted);
  }, [userPrefMuted, setMuted]);
  const props = { toggleMute, muted, mutedByBrowser };
  return /* @__PURE__ */ React31.createElement(VideoContainer, { className }, isHovered && /* @__PURE__ */ React31.createElement(
    VideoStyled,
    {
      gif,
      key: gif.id,
      loop: true,
      controls: true,
      hideAttribution: true,
      hideMute: true,
      persistentControls: true,
      muted,
      width,
      height,
      onMuted: setMutedByBrowser
    }
  ), !hideMuteButton && /* @__PURE__ */ React31.createElement(VolumeButton, __spreadProps(__spreadValues({}, props), { isHovered })));
};
VideoOverlay.imgClassName = speakerClassName;
var video_overlay_default = VideoOverlay;

// src/index.ts
appendGiphySDKRequestHeader(`X-GIPHY-SDK-NAME`, "ReactSDK");
export {
  attribution_default as Attribution,
  overlay_default as AttributionOverlay,
  carousel_default as Carousel,
  EmojiVariationsList,
  gif_default as Gif,
  grid_default as Grid,
  loader_default as Loader,
  PauseIcon,
  PingbackContext,
  PlayIcon,
  PlayPauseSize,
  search_bar_default as SearchBar,
  SearchContext,
  context_default as SearchContextManager,
  suggestion_bar_default as SuggestionBar,
  verified_badge_default as VerifiedBadge,
  video_default2 as Video,
  video_overlay_default as VideoOverlay,
  VolumeOffIcon,
  VolumeOnIcon,
  VolumeSize
};
